import Fragment from 'ynf-core-engine/Fragment';


export default async (isFw) => {
  return new Promise((resolve, reject)=>{
    if (isFw) {
      console.log('%cFragment: 进入了BizFlowWorkbench进行渲染', 'color: green; font-size:3em')
      console.log('%c业务组件 ynf-fw-businessflow-lib/BizFlowWorkbench', 'color: blue; font-size:2em')
      import('ynf-fw-businessflow-lib/BizFlowWorkbench').then(module => {
        resolve(module.default)
      })
      console.log('=====[推单]YNF businessflow lib: =======', isFw)
    }else{
      console.log('=====[推单]YNF Fragment 渲染: =======')
      window.YNFFragment = Fragment
      resolve(Fragment)
    }
  })
}
